module.exports = __webpack_public_path__ + "img/course-march.22005653.jpg";